import {
  SET_LOADING_DATA,
  SET_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_PER_PAGE,
  SET_ORDER,
  SET_ORDERBY,
  SEARCH,
  SET_LOADING_SEND,
  GET_BY_ID_REQUEST,
  GET_BY_ID_SUCCESS,
  EDIT_ITEM,
  DELETE_ITEM,
  GET_LIST_BONIFICATION_PRODUCT_REQUEST,
  GET_LIST_BONIFICATION_PRODUCT_SUCCESS,
  SAVE_BONIFICATION_PRODUCT_REQUEST,
  SAVE_BONIFICATION_PRODUCT_SUCCESS,
  GET_SELECTS_SUCCESS,
  GET_PRODUCTS_REQUEST,
  GET_PRODUCTS_SUCCESS,
  SET_LOADING_SELECTS
} from './bonification-product-constants';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const setLoadingSend = (loading: Boolean) => {
  return {
    type: SET_LOADING_SEND,
    loading
  };
};

export const setLoadingSelects = (loading: Boolean) => {
  return {
    type: SET_LOADING_SELECTS,
    loading
  };
};

export const getAllBonificationProductRequest = () => {
  return {
    type: GET_LIST_BONIFICATION_PRODUCT_REQUEST
  };
};

export const getAllBonificationProductSuccess = payload => {
  return {
    type: GET_LIST_BONIFICATION_PRODUCT_SUCCESS,
    payload
  };
};

export const editItem = (id: string) => {
  return {
    type: EDIT_ITEM,
    id
  };
};

export const deleteItem = (id: string) => {
  return {
    type: DELETE_ITEM,
    id
  };
};

export const getByIdRequest = (id: string) => {
  return {
    type: GET_BY_ID_REQUEST,
    id
  };
};

export const getByIdSuccess = (payload: any) => {
  return {
    type: GET_BY_ID_SUCCESS,
    payload
  };
};

export const getSelectsSuccess = (payload: any) => {
  return {
    type: GET_SELECTS_SUCCESS,
    payload
  };
};

export const saveBonificationRequest = (payload: any, id?: string) => {
  return {
    type: SAVE_BONIFICATION_PRODUCT_REQUEST,
    payload,
    id
  };
};

export const saveBonificationSuccess = (payload: any) => {
  return {
    type: SAVE_BONIFICATION_PRODUCT_SUCCESS,
    payload
  };
};

export const setPage = (page: Number) => {
  return {
    type: SET_PAGE,
    page
  };
};

export const setRowsPerPage = (rowsPerPage: Number) => {
  return {
    type: SET_ROWS_PER_PAGE,
    rowsPerPage
  };
};

export const setRowsCount = (rowsCount: Number) => {
  return {
    type: SET_ROWS_COUNT,
    rowsCount
  };
};

export const setOrder = (order: String) => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (orderBy: (string | boolean)[]) => {
  return {
    type: SET_ORDERBY,
    orderBy
  };
};

export const search = (queryString: string) => {
  return {
    type: SEARCH,
    queryString
  };
};

export const getProductsRequest = ({ queryString, skip }: { queryString?: string; skip?: number }) => {
  return {
    type: GET_PRODUCTS_REQUEST,
    queryString,
    skip
  };
};

export const getProductsSuccess = payload => {
  return {
    type: GET_PRODUCTS_SUCCESS,
    payload
  };
};
